import { render, staticRenderFns } from "./TreatyRI.vue?vue&type=template&id=0bd2318a&"
import script from "./TreatyRI.vue?vue&type=script&lang=js&"
export * from "./TreatyRI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports